import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { RepoBulkAnswer } from '../lib/repo-enablement';
import { count } from '../lib/time';
import { RepoEnablementPace } from './RepoEnablementPace';
import { RepoEnablementRefusals } from './RepoEnablementRefusals';

/** The act's outcome, partial results included. `role="status"`: it lands after the dialog closes. */
export function RepoEnablementResult(props: { readonly answer: RepoBulkAnswer }): JSX.Element {
  const key = (): string =>
    props.answer.action === 'enable'
      ? 'repo_enablement.result_enabled'
      : 'repo_enablement.result_disabled';
  return (
    <div class="repo-enablement__result" role="status">
      <Show
        when={!props.answer.dry_run}
        fallback={<p class="repo-enablement__line">{t('repo_enablement.nothing_to_do')}</p>}
      >
        <p class="repo-enablement__line">
          {tPlural(key(), props.answer.applied, { shown: count(props.answer.applied) })}
        </p>
      </Show>
      <RepoEnablementRefusals answer={props.answer} />
      <Show when={props.answer.failed.count > 0}>
        <p class="repo-enablement__line" role="alert">
          {tPlural('repo_enablement.failed', props.answer.failed.count, {
            shown: count(props.answer.failed.count),
          })}
        </p>
      </Show>
      <Show when={!props.answer.dry_run}>
        <RepoEnablementPace answer={props.answer} />
      </Show>
    </div>
  );
}
